module.exports = __webpack_public_path__ + "08_mole.aa0e4ae4.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer2/08_mole.png
// module id = rL/F
// module chunks = 0